import React, { createContext, useState, useContext, useEffect } from 'react';
import config from './config.js';

const VALID_THEMES = ['songshake', 'banana-split', 'black-forest'];

const resolveTheme = () => {
  const storedTheme = sessionStorage.getItem('theme');
  return VALID_THEMES.includes(storedTheme) ? storedTheme : config.defaultTheme;
};

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => resolveTheme());

  useEffect(() => {
    const root = document.documentElement;
    const nextTheme = resolveTheme();
    root.setAttribute('data-theme', nextTheme);
    setTheme(nextTheme);
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    root.setAttribute('data-theme', theme);
  }, [theme]);

  const applyStoredTheme = () => {
    const nextTheme = resolveTheme();
    const root = document.documentElement;
    root.setAttribute('data-theme', nextTheme);
    setTheme(nextTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, setTheme, applyStoredTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);